import { Action } from 'redux';
import { FullstoryCustomerData } from '../@types';

export enum FullstoryActionType {
	RequestInitialize = 'requestFullstoryInitialize'
}

export type FullstoryInitializeAction = Action<typeof FullstoryActionType.RequestInitialize> & {
	data: FullstoryCustomerData;
};

export function requestInitializeFullstory(data: FullstoryCustomerData): FullstoryInitializeAction {
	return {
		data,
		type: FullstoryActionType.RequestInitialize
	};
}
